<div class="d-flex align-items-center justify-content-center align-self-stretch app-card-dotted-edges w-100">
    <ng-content></ng-content>
</div>